import { Helmet } from "react-helmet-async";
import { site } from "@/content";

interface SeoHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
}

export default function SeoHead({
  title,
  description,
  keywords,
  canonicalPath,
  ogTitle,
  ogDescription,
  ogImage,
}: SeoHeadProps) {
  const base = site.brand.url;
  const canonical = `${base}${canonicalPath}`;
  const ogT = ogTitle || title;
  const ogD = ogDescription || description;
  const ogI = ogImage || site.seo.defaultOgImage;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={site.seo.author} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={ogT} />
      <meta property="og:description" content={ogD} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogI} />
      <meta property="og:locale" content="ru_RU" />
      <meta property="og:site_name" content={site.seo.siteName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogT} />
      <meta name="twitter:description" content={ogD} />
      <meta name="twitter:image" content={ogI} />
      <meta name="ai-purpose" content="business website" />
      <meta name="ai-searchable" content="true" />
      <meta name="ai-service-type" content="crm consulting, automation, lean consulting" />
    </Helmet>
  );
}